import React from 'react';
import { Button, CircularProgress } from '@mui/material';
import { AutoAwesome as AutoAwesomeIcon } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { TranslateButtonProps } from './types';

export const TranslateButton: React.FC<TranslateButtonProps> = ({
  canTranslate,
  loading,
  targetLanguageDisplay,
  onTranslate
}) => {
  const { t } = useTranslation();

  return (
    <Button
      variant="contained"
      onClick={onTranslate}
      disabled={!canTranslate || loading}
      startIcon={loading ? <CircularProgress size={20} color="inherit" /> : <AutoAwesomeIcon />}
      sx={{
        py: 0.5,
        px: 2,
        minHeight: 34,
        width: 'fit-content',
        alignSelf: 'flex-start',
        fontSize: '0.875rem',
        fontWeight: 600,
        borderRadius: 1,
      }}
    >
      {loading
        ? t('translation.generating')
        : canTranslate
          ? t('translation.generateButton', { language: targetLanguageDisplay })
          : t('translation.generateHint')
      }
    </Button>
  );
};
